import type { Game } from '../game/Game';
import { registerOverlay, registerPanel } from '../ui/app/App';
import { NetSession, pickMode } from './NetSession';
import { ChatBox, Invites, QueueWidget, ReadyCheck, SocialPanel, TradeWindow, setNetSession } from './ui/NetUi';

/** Installs multiplayer: transport, zone replication, social features and their UI. */
export function install(game: Game): NetSession {
  const session = new NetSession(game);
  game.net = session;
  setNetSession(session);
  registerPanel('party', SocialPanel);
  for (const o of [ChatBox, Invites, ReadyCheck, QueueWidget, TradeWindow]) registerOverlay(o);
  session.start(pickMode(game.account.settings.online, location.search));
  return session;
}
